import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const EditLineIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 16 16" stroke="none">
      <path d="M4.50888 10.4313L10.8477 4.09248L9.96381 3.20859L3.625 9.54744V10.4313H4.50888ZM5.02665 11.6813H2.375V9.02963L9.52188 1.88276C9.766 1.63869 10.1617 1.63869 10.4058 1.88276L12.1736 3.65053C12.4176 3.89461 12.4176 4.29034 12.1736 4.53441L5.02665 11.6813ZM2.375 12.9313H13.625V14.1813H2.375V12.9313Z" />
    </BaseSVG>
  )
}
